import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Fetch } from "../../../shared/Fetch";
import { JVDate } from "../../../shared/JVDate";
import { ICompanyMastDropdown, IBranchMastDropdown, ITeamsDropdown } from "../../../models/IDropdown";
import { JVDropdown } from "../../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { ILogin } from "../../../models/Login";
import { JVInput } from "../../../shared/JVInput";
import { Dropdown } from "primereact/dropdown";
import { format } from "date-fns";


export interface IRecRepFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    report_Type?: string | null,
    status?: string | null,
    consultant?: string | null
}

export const EmptyRecRepFilter: IRecRepFilter = {
    fromDate: null,
    toDate: null,
    report_Type: "",
    status: null
}


interface Iprops {
    salEffFilter: IRecRepFilter,
    setSalEffFilter: (salEffFilter: IRecRepFilter) => void,
    onSearch: () => void;
}

export const Filter = (props: Iprops) => {


    const [selecteduser, setselectedUser] = useState<any | null>(null);
    const [user, setUser] = useState<Array<any>>();


    const { control, handleSubmit, reset, watch } = useForm<IRecRepFilter>({
        defaultValues: props.salEffFilter,
        shouldFocusError: false
    });




    const loadUser = async () => {
        const response = await Fetch("Dropdown/getConsultantName", "GET", null, null, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                consultant_ID: 0,
                consultant_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setUser(data);
        }
    }

    const searchToDB = async (body: IRecRepFilter) => {
        let filterData: any = body;
        let emptyFilter: any = EmptyRecRepFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setSalEffFilter(body);
    }


    function onSubmit(data: IRecRepFilter) {
        data.consultant = selecteduser
        searchToDB(data);
         props.onSearch();
    }

    useEffect(() => {
        loadUser();
    }, []);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
            <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
            <div style={{ width: '20%', marginLeft: '10px' }} >
                <label className="" style={{ display: 'block', marginBottom: '8px' }}>Consultant Name</label>
                <Dropdown value={selecteduser} onChange={(e) => {
                    setselectedUser(e.value);
                }} options={user} optionLabel="consultant_Name" placeholder="Select Consultant" optionValue="consultant_ID"
                    filter className="w-full" />
            </div>
            <div className="p-field p-col-12 p-md-6 p-d-flex p-ai-end p-jc-between" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '24px', marginLeft: '20px', marginBottom: '-11px', width: "30%" }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyRecRepFilter); setselectedUser(null); }} type="button"></Button>
            </div>
        </form>
    );
}
